<template>
	<div :class="[isDetail ? 'c-productdetail__amount--control' : 'c-product__amount--control']">
		<div :class="['c-product__amount--minus', { disabled: totalAmount < priceOrderRatio*2 }]" tabindex="0" @click="minusAmount" @keyup.enter="minusAmount"><i class="far fa-minus" /><span class="sr-only">Minder</span></div>
		<div class="c-product__amount--nr">
			<input v-if="priceOrderRatio % 1 !== 0" :value="getDisplayAmount()" name="amount" min="1" :disabled="priceOrderRatio != 1" :class="{ smaller: totalAmount.length === 5, smallest: totalAmount.length > 5 }" />
			<input v-else v-model="totalAmount" type="number" name="amount" min="1" :disabled="priceOrderRatio != 1" :class="{ smaller: totalAmount.length === 5, smallest: totalAmount.length > 5 }" @keypress="isNumber($event)" @change="setAmount()" />
		</div>
		<div class="c-product__amount--plus" tabindex="0" @click="plusAmount" @keyup.enter="plusAmount"><i class="far fa-plus" /><span class="sr-only">Meer</span></div>
	</div>
</template>


<script>
// Use an array of timeouts, because this component can exist multiple times
const setAmountTimeouts = [];

export default {
	props: {
		amount: {
			type: Number,
			required: true
		},
		timeout: {
			type: Boolean,
			default: false
		},
		isDetail: {
			type: Boolean,
			default: false
		},
		priceOrderRatio: {
			type: Number,
			required: false,
			default: 0
		}
	},
	data() {
		return {
			totalAmount: this.amount
		};
	},
	watch: {
		amount: function(newVal, oldVal) {
			this.totalAmount = newVal;
		}
	},
	methods: {
		getDisplayAmount(){
			const amountString = this.amount + '';
			return amountString.replace('.',',');
		},
		isNumber: function(evt) {
			evt = evt || window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		minusAmount() {
			window.clearTimeout(setAmountTimeouts[this._uid]);
			this.totalAmount = this.totalAmount - this.priceOrderRatio;
			if(!Number.isInteger(this.totalAmount)){
				const priceOrderRatioString = this.priceOrderRatio + '';
				const priceOrderRatioAccuracy = priceOrderRatioString.split('.')[1].length;

				this.totalAmount = parseFloat(this.totalAmount.toFixed(priceOrderRatioAccuracy));
			}
			setAmountTimeouts[this._uid] = window.setTimeout(this.setAmount, this.timeout ? 750 : 0);
		},

		plusAmount() {
			window.clearTimeout(setAmountTimeouts[this._uid]);
			this.totalAmount = this.totalAmount + this.priceOrderRatio;
			if(!Number.isInteger(this.totalAmount)){
				const priceOrderRatioString = this.priceOrderRatio + '';
				const priceOrderRatioAccuracy = priceOrderRatioString.split('.')[1].length;

				this.totalAmount = parseFloat(this.totalAmount.toFixed(priceOrderRatioAccuracy));
			}
			setAmountTimeouts[this._uid] = window.setTimeout(this.setAmount, this.timeout ? 750 : 0);
		},

		setAmount() {
			this.$emit('changeAmount', +this.totalAmount);
		}
	}
};
</script>